import React, {memo} from "react";
import Skeleton, {SkeletonProps} from 'react-loading-skeleton';
import styled from "styled-components/macro";
import {device} from "../../styles";

const Root = styled.div`
    display: flex;
    gap: 12px;
    align-items: center;
    
    ${device.less768} {
        
    }
`;

const Input = styled.div`
    width: 20px;
    height: 20px;

    ${device.less768} {
        display: none;
    }
`;

const Label = styled.div`
    width: 80%;
    height: 20px;

    ${device.less768} {
        width: 100%;
        height: 34px;
        
        * {
            height: 34px;
        }
    }
`;

export const RadioSkeleton = memo((props: SkeletonProps) => (
    <Root>
        <Input>
            <Skeleton height={'100%'} />
        </Input>

        <Label>
            <Skeleton height={'100%'} />
        </Label>
    </Root>
));
